import { render, staticRenderFns } from "./PdvClosedPost.vue?vue&type=template&id=8ec77d74"
import script from "./PdvClosedPost.vue?vue&type=script&lang=js"
export * from "./PdvClosedPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports